import { createCachedSelector } from "re-reselect";

import type { RelatedPublicSegment } from "@busbud/core-types/dist/lib/poll-service/api/udm";

import {
  getTripSegmentsByVehicleLayout,
  UNKNOWN_LAYOUT
} from "@app/helpers/udm/vehicle";

import { getTripById } from "./get-trip";
import { getTripsSegments } from "../state-accessors";

const EMPTY_ARRAY: RelatedPublicSegment[] = [];
export const getSegmentsWithUnknownVehicleLayout = createCachedSelector(
  [getTripsSegments, getTripById],
  (segments, trip) => {
    if (!segments || !trip) {
      return EMPTY_ARRAY;
    }
    return getTripSegmentsByVehicleLayout(UNKNOWN_LAYOUT, segments, trip);
  }
)((_state, trip_id) => trip_id);
